import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useShop = () => {
	const { getShop } = useAxios()
	const { isLoading, data } = useQuery('boutiques', getShop)

	if (isLoading) return { isLoading }

	const { title, content } = data

	return {
		isLoading,
		title,
		content,
		figures: [
			{ figure: '1 206 ', label: 'tonnes d’objets collectés' },
			{ figure: '682 238 ', label: 'objets sauvés' },
			{ figure: '85', label: 'salariés accompagnés' },
			{ figure: '515', label: 'ateliers comptants 4 160 participants' },
			{ figure: '4 227', label: 'créations artisanales' },
		],
	}
}

export default useShop
